import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { InternalValuationStore } from '../stores/internalValuationStore';

export const useInternalValuationStore = () =>
  useContext<{
    internalValuationStore: InternalValuationStore;
  }>(StoreContext);
